import * as React from 'react'

import TextField, { defaultTextFieldProps } from './BaseTextField'
import { ITextFieldProps } from './types'

interface IProps extends ITextFieldProps {
  onChange: (value: string) => void
  cleaveDatePattern: string[]
}

const cleaveOptions = {
  date: true,
}

function DateTextField(props: IProps) {
  const { onChange, cleaveDatePattern, ...moreProps } = props

  return (
    <TextField
      {...moreProps}
      cleaveOptions={{ ...cleaveOptions, datePattern: cleaveDatePattern }}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
    />
  )
}

DateTextField.defaultProps = {
  ...defaultTextFieldProps,
  cleaveDatePattern: ['m', 'd', 'Y'],
}

export default React.memo(DateTextField)
